/**
 * 年度算出の共通関数。
 *
 * ⚠️ `fiscalPositionOfMonth` は `apps/api/src/lib/fiscal-year.ts` の同名関数と
 *    完全に同一のロジック (文字列split方式、`new Date()`を使わない純関数) を移植したもの。
 *    サーバー側の年度算出と食い違わせないため、**変更する場合は両方を同時に直すこと**
 *    (web/apiは別デプロイのため直接importできず、コピーで整合を保つ)。
 *    設計: docs/design/v05-dashboard-scope-pinning.md §0-2-4
 */

/** 当月の月初 'YYYY-MM-01' (TrendsPage.tsx 等の既存実装と同一)。 */
export const currentMonthStart = (): string => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
};

/** 'YYYY-MM-01' (または 'YYYY-MM') がどの年度・四半期に属するかを返す (純関数)。 */
export const fiscalPositionOfMonth = (
  month: string, startMonth: number,
): { fiscalYear: number; quarter: number } => {
  const [y, m] = month.split('-').map((s) => Number.parseInt(s, 10));
  const offset = (m! - startMonth + 12) % 12;
  const fiscalYear = m! >= startMonth ? y! : y! - 1;
  return { fiscalYear, quarter: Math.floor(offset / 3) + 1 };
};

/** 当月が属する年度。`fiscalPositionOfMonth(currentMonthStart(), startMonth).fiscalYear` のラッパー。 */
export const currentFiscalYear = (startMonth: number): number =>
  fiscalPositionOfMonth(currentMonthStart(), startMonth).fiscalYear;
